// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"99":"e57e837d","239":"d506dd07","349":"40b084a4","354":"da8607e2","442":"583c3852","453":"eb9d2829","521":"3a9fad80","538":"96e17f01","555":"e3961c60","610":"8cdd05de","806":"362b001e","813":"06827c5a","963":"1f1e5a68","988":"da4b578c"}[chunkId] + ".chunk.js";
};